import { render, staticRenderFns } from "./InspectionTooltip.vue?vue&type=template&id=38856819&scoped=true"
import script from "./InspectionTooltip.vue?vue&type=script&lang=js"
export * from "./InspectionTooltip.vue?vue&type=script&lang=js"
import style0 from "./InspectionTooltip.vue?vue&type=style&index=0&id=38856819&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38856819",
  null
  
)

export default component.exports